/* Routing helpers */
import React from "react";
import { roles } from "../../../../index";
import DepositsEdit from "../pages/edit/deposits/DepositsEdit";
import TransactionsEdit from "../pages/edit/transactions/TransactionsEdit";

import DepositsList from "../pages/list/DepositsList";

import { List } from "../pages/list/List";
import TransactionsList from "../pages/list/TransactionsList";
import { WALLET_CONTEXT } from "./ModuleHelpers";

export const ROUTE_PREFIX = "/" + WALLET_CONTEXT;

export const ROUTES = {
  new: {
    path: `${ROUTE_PREFIX}/new`,
    component: () => <div>New</div>,
    accepts: [roles.super_admin, roles.provider],
  },
  // edit: {
  //   path: `${ROUTE_PREFIX}/:slug/edit`,
  //   component: <div>Edit</div>,
  //   accepts: [roles.super_admin],
  // },
  list: {
    path: `${ROUTE_PREFIX}/list`,
    component: List,
    accepts: [roles.visitor, roles.client, roles.provider, roles.super_admin],
  },
  depositsList: {
    path: `${ROUTE_PREFIX}/deposits`,
    component: DepositsList,
    accepts: [roles.client, roles.provider, roles.super_admin],
  },
  depositsEdit: {
    path: `${ROUTE_PREFIX}/deposits/:id/edit`,
    component: DepositsEdit,
    accepts: [roles.super_admin],
  },

  transactionsList: {
    path: `${ROUTE_PREFIX}/transactions`,
    component: TransactionsList,
    // accepts: [roles.visitor, roles.client, roles.provider, roles.super_admin],
    accepts: [roles.super_admin],
  },
  transactionsEdit: {
    path: `${ROUTE_PREFIX}/transactions/:id/edit`,
    component: TransactionsEdit,
    accepts: [roles.super_admin],
  },
};
export const ROUTE_DEFAULT = ROUTES.list.path;
